import EntityListManager from './EntityListManager';
import {
  getProjectStatuses,
  createProjectStatus,
  updateProjectStatus,
  deleteProjectStatus,
  reorderProjectStatuses,
} from '../../services/projectService';

export default function ProjectStatusManager({ onMessage }) {
  return (
    <EntityListManager
      onMessage={onMessage}
      title="Project Statuses"
      description="Manage project statuses used for grouping, filtering, and tracking progress."
      entityNoun="Status"
      entityNounPlural="Statuses"
      idKey="status_id"
      namePlaceholder="e.g. On Hold, In Review, QA"
      load={() => getProjectStatuses().then((d) => d.statuses)}
      create={createProjectStatus}
      update={updateProjectStatus}
      remove={deleteProjectStatus}
      reorder={(ids) => reorderProjectStatuses(ids).then((d) => d.statuses)}
      protectDefaultRename
      protectDefaultDelete
      deleteWarning={(item) => `Are you sure you want to delete the "${item.name}" status? Projects using this status will be moved to the first available status.`}
    />
  );
}
